import React, { Fragment, useEffect, useState } from 'react';
import { Settings } from 'react-feather';
import { Link } from 'react-router-dom';
import { H6, Image, LI, UL, P } from '../../AbstractElements';
import man from '../../assets/images/dashboard/1.png';
import { useQuery } from 'react-query';

import { getProfile } from '../../MyApi/admin/profile';

const Profile = () => {

   
 
  





    return (
        <Fragment>
            {/* <div className="sidebar-user text-center">
                <Link to={"/admin/profile"} className="setting-primary" href="#javascript">
                    <Settings />
                </Link>
                 <Link to={`${process.env.PUBLIC_URL}/admin/profile`}> 
                     <Image attrImage={{ className: 'img-90 rounded-circle ', src:  `${image}`, alt: '' }} /> 
                    <div className="badge-bottom">
                        <div className="badge badge-primary">
                        {`${
                active  ? "Active" :  "Inactive"
          }`}
                        </div>
                    </div>
                    <H6 attrH6={{ className: 'mt-3 f-14 f-w-600' }} >{name}</H6>
                </Link> 
                 <P attrPara={{ className: 'mb-0 font-roboto' }} >{name}</P>
                <UL attrUL={{ className: 'flex-row simple-list' }}>
                    <LI><span><span className="counter">19.8</span>k</span>
                        <P>Follow</P>
                    </LI>
                    <LI><span>2 year</span>
                        <P>Experince</P>
                    </LI>
                    <LI><span><span className="counter">95.2</span>k</span>
                        <P>Follower </P>
                    </LI>
                </UL> 
            </div> */}
        </Fragment >
    );
};

export default Profile;